import { useQuery } from '@tanstack/react-query';

import StaffEnrollmentRepository from '@/repositories/StaffEnrollmentRepository';

export const useStaffEnrollment = (
  staffId: string | undefined,
  personId?: string,
  debug: boolean = false,
  enabled: boolean = true,
  manualParams?: {
    jurisdiction?: string;
    insuranceProvider?: string;
    insuranceType?: string;
    programScope?: string;
    onlyActive?: boolean;
  }
) => {
  const staffEnrollmentRepository = StaffEnrollmentRepository();

  return useQuery({
    queryKey: ['staffEnrollment', staffId, personId, debug, manualParams],
    queryFn: () => {
      if (!staffId) {
        throw new Error('Staff ID is required');
      }
      return staffEnrollmentRepository.getStaffEnrollment(staffId, personId, debug, manualParams);
    },
    enabled: enabled && !!staffId
  });
};
